module.exports = __webpack_public_path__ + "img/rec-cost.ca5431c9.png";